<template>
  <el-collapse-item class="my-collapse"  :name="name">
    <template slot="title">
      <div class="title-view">
        <img :src="iconPath" v-if="iconPath" class="title-icon"  alt="">
        <span>{{ title}}</span>
      </div>
    </template>
    <div class="collapse-content">
      <slot></slot>
    </div>

  </el-collapse-item>
</template>

<script>
export default {
  name: "MyCollapse",
  props:{
    title:'',
    iconPath:'',
    name:'',
  },
}
</script>

<style lang="scss" scoped>
@import "src/common/common";
@import "src/common/form";
.my-collapse{
  background: #FFFFFF ;
  margin-bottom: 20px;
  border-radius: 5px;
  //padding-top: 10px;
  overflow: hidden;
  .title-view{
    display: flex;
    align-items: center;
    .title-icon{
      width: 20px;height: 20px;
      margin-right: 10px;
    }
  }

}
/deep/ .el-collapse-item__header{
  border-bottom-color: rgba(232, 85, 111, 0) !important;
  width: calc(100% - 40px);
  margin: 0 20px;
  //height: 40px;
  font-size: 16px;
  font-weight: 500;
}
/deep/ .el-icon-arrow-right:before{
  color: #e8556f;
  font-size: 20px;
  font-weight: 600;
}
/deep/ .el-collapse-item__header.is-active{
  border-bottom-color: #e5e5e5 !important
}
  .collapse-content{
    padding: 20px 20px 0 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/business/MyCollapse.vue